export default function Meta({ title }){
    return(
        <>
        <title>{title}</title>
        </>
    )
}

